import BasePagination from 'legacy/src/components/questionBank/Pagination';
import { withRouter } from 'react-router';
import React from 'react';

const Pagination = (props) => {
  const {
    pathname,
    totalPages,
    currentPage,
    location: { query },
    router,
    className,
  } = props;

  const pageLink = (page) => ({ pathname, query: { ...query, page } });

  const nextPage = currentPage < totalPages - 1 && pageLink(currentPage + 1);
  const prevPage = currentPage > 0 && pageLink(currentPage - 1);

  const hasPageAfterNext = currentPage + 2 < totalPages;
  const afterNextPage = hasPageAfterNext && pageLink(currentPage + 2);
  const hasLastPage = currentPage + 2 < totalPages - 1;
  const lastPage = hasLastPage && pageLink(totalPages - 1);
  const firstPage = pageLink(0);

  return (
    <BasePagination
      onButtonClick={() => {
        // when click on button pagination scroll window to the top
        window.scrollTo(0, 0);
      }}
      className={`pagination ${className}`}
      router={router}
      currentPage={currentPage + 1}
      total={totalPages}
      nextPage={nextPage}
      prevPage={prevPage}
      lastPage={lastPage}
      afterNextPage={afterNextPage}
      firstPage={firstPage}
    />
  );
};

export default withRouter(Pagination);
